import { unref, type Ref } from 'vue'
import { toast } from 'vue3-toastify'

// vuelidate 的 $message 经 createI18nMessage 包装后由 core 包成 computed ref，
// 直接插值或 join 会被渲染成 [object Object]，这里统一解包成字符串数组
export const resolveErrorMessages = (messages?: (string | Ref<string> | undefined)[]): string[] =>
  (messages ?? []).map((m) => unref(m)).filter((m): m is string => !!m)

export const logSuccess = (res: any) => {
  /* eslint-disable-next-line */
  console.log('%c Request Success: %s', 'color: #4CAF50; font-weight: bold', res.config.url, res)
  return res
}

export const logError = (err: any) => {
  /* eslint-disable-next-line */
  console.log('%c Request Error:', 'color: #EC6060; font-weight: bold', err)
  return Promise.reject(err)
}

// errors 的结构并不固定：可能是 { field: [msg] }，也可能是 [{ message: msg }] 或嵌套对象，
// 逐层拍平成字符串，避免把对象直接塞进 toast 渲染成 [object Object]
const flattenErrorMessages = (val: any): string[] => {
  if (val == null) return []
  if (typeof val === 'string') return [val]
  if (Array.isArray(val)) return val.flatMap(flattenErrorMessages)
  if (typeof val === 'object') return flattenErrorMessages(Object.values(val))
  return [String(val)]
}

export const displayErrors = (err: any) => {
  const data = err?.response?.data ?? err
  const messages = flattenErrorMessages(data?.errors)
  if (messages.length) {
    messages.forEach((description) => toast.warning(description))
    return
  }
  const fallback = flattenErrorMessages(data?.message)
  toast.error(fallback.join('\n') || 'Request failed, please try again.')
}

export const scrollToTwBorderError = () => {
  // 用 center 而不是对齐视口顶部，避免出错的字段被吸顶导航栏遮住
  document.getElementsByClassName('tw-border-error')?.[0]?.scrollIntoView({ block: 'center', behavior: 'smooth' })
}
